// 用途说明按换行拆分并 trim（Funding / Channel 两 grid 共用，纯展示拆分、无关键词高亮）。
// ProductGrid 的 highlightedPurpose 额外做关键词高亮，逻辑不同，不走此函数。
export function splitPurposeByLine(purpose) {
  if (!purpose) return [];
  return purpose.split('\n').map((part) => part.trim());
}
